import {isPlatformBrowser} from '@angular/common';
import {Component, EventEmitter, Inject, Input, Output, PLATFORM_ID,} from '@angular/core';
import {SizeProfile} from 'src/app/product-details/interface/size-profile';
import {SizeProfileGuideItem} from 'src/app/product-details/interface/size-profile-guide-item';
import {SizeProfileOptionItem} from 'src/app/product-details/interface/size-profile-option-item';

export interface NewSizeArray {
	guide: string
	guideNumber: number[]
}
@Component({
	selector: 'fb-choose-size-more-option',
	templateUrl: './choose-size-more-option.component.html',
	styleUrls: ['./choose-size-more-option.component.scss']
})
export class ChooseSizeMoreOptionComponent {

	constructor(
		@Inject(PLATFORM_ID) private _platformId: Object
	){
		this.isBrowser = isPlatformBrowser(this._platformId);
	}
	public isBrowser: boolean = false;
	@Output() closeSizeGuide = new EventEmitter<boolean>();
	@Input() sizeDataPassOne: SizeProfile = {} as SizeProfile;

	public isFabricProduct: boolean = false;
	public inCm: boolean = false;
	public openSide: boolean = false;

	public closeSlider(): void {
		this.closeSizeGuide.emit(false)
	}

	public sizeMetrics(): void {
		this.inCm = !this.inCm;
		console.log(this.inCm);
	}
	public newSizeArray: NewSizeArray[] = [];

	public ngOnInit(): void {

		// console.log(this.sizeDataPassOne);
		let sizeList: SizeProfileOptionItem[] = this.sizeDataPassOne.sizeProfileOptionList;
		let guideList: SizeProfileGuideItem[] = this.sizeDataPassOne.sizeProfileGuideList;
		let newarr: string[] = [];
		guideList.forEach((elm: SizeProfileGuideItem) => {
			newarr.push(elm.guide)
		})
		newarr = [...new Set(newarr)]; // only unique item

		this.newSizeArray = newarr.map((guide: string) => ({ guide: guide, guideNumber: [] }));


		this.newSizeArray.forEach((newSizeList: NewSizeArray, i: number) => {

			sizeList.forEach((sizeProfileOption: SizeProfileOptionItem, i: number) => {

				guideList.forEach((sizeProfileGuide: SizeProfileGuideItem, m: number) => {

					if (sizeProfileOption.id == sizeProfileGuide.sizeProfileOptionId) {

						if (newSizeList.guide == sizeProfileGuide.guide) {
							newSizeList.guideNumber.push(sizeProfileGuide.value)
						}
					}
				})
			})
		});
		if (this.isBrowser) {
			if (window.location.href.includes('product/fabric-product/')) {
				this.isFabricProduct = true;
			}
		}

		// debugger
		// console.log(this.newSizeArray)
	}
}
